import React from 'react';

// ── SVG Donut Chart — theme-aware (light admin bg vs dark hostel bg) ───
export function DonutChart({ segments, size = 130, dark = false }) {
  segments = segments.map(seg => ({ ...seg, value: Number(seg.value) || 0 }));
  const total = segments.reduce((s, seg) => s + seg.value, 0) || 1;
  const r = 46, cx = 65, cy = 65, circ = 2 * Math.PI * r;
  let offset = 0;
  const trackColor = dark ? 'rgba(255,255,255,0.06)' : '#eef1f8';
  const labelColor = dark ? '#e2e8f0' : '#1a2340';
  const subColor = dark ? '#64748b' : '#94a0bf';

  return (
    <svg width={size} height={size} viewBox="0 0 130 130">
      <circle cx={cx} cy={cy} r={r} fill="none" stroke={trackColor} strokeWidth="15" />
      {segments.map((seg, i) => {
        if (!seg.value) return null;
        const arc = (seg.value / total) * circ;
        const dashOffset = -offset;
        offset += arc;
        return (
          <circle
            key={i} cx={cx} cy={cy} r={r} fill="none" stroke={seg.color} strokeWidth="15"
            strokeDasharray={`${arc} ${circ}`} strokeDashoffset={dashOffset}
            strokeLinecap="butt" style={{ transform: 'rotate(-90deg)', transformOrigin: '50% 50%' }}
          />
        );
      })}
      <text x={cx} y={cy - 4} textAnchor="middle" fill={labelColor} fontSize="20" fontWeight="800">{total === 1 && !segments.some(s => s.value) ? 0 : segments.reduce((s, seg) => s + seg.value, 0)}</text>
      <text x={cx} y={cy + 14} textAnchor="middle" fill={subColor} fontSize="9.5" fontWeight="600" letterSpacing="0.05em">TOTAL</text>
    </svg>
  );
}

export function DonutLegend({ segments, dark = false }) {
  return (
    <div style={{ display: 'grid', gap: '6px' }}>
      {segments.map((seg, i) => (
        <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '12.5px', color: dark ? 'rgba(255,255,255,0.75)' : 'var(--text-secondary)' }}>
          <span style={{ width: '10px', height: '10px', borderRadius: '3px', background: seg.color, flexShrink: 0 }} />
          <span style={{ flex: 1 }}>{seg.label}</span>
          <strong style={{ color: dark ? '#fff' : 'var(--text-primary)' }}>{seg.value}</strong>
        </div>
      ))}
    </div>
  );
}

// ── Horizontal Bar Chart ─────────────────────────────────────────────
export function BarRow({ label, value, max, color, dark = false, formatValue }) {
  const pct = max > 0 ? Math.min((value / max) * 100, 100) : 0;
  const trackColor = dark ? 'rgba(255,255,255,0.06)' : '#eef1f8';
  const labelColor = dark ? '#94a3b8' : 'var(--text-secondary)';
  return (
    <div style={{ marginBottom: '12px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
        <span style={{ fontSize: '12px', color: labelColor }}>{label}</span>
        <span style={{ fontSize: '12px', fontWeight: '700', color }}>{formatValue ? formatValue(value) : value}</span>
      </div>
      <div style={{ background: trackColor, borderRadius: '6px', height: '8px', overflow: 'hidden' }}>
        <div style={{ width: `${pct}%`, height: '100%', background: color, borderRadius: '6px', transition: 'width 0.8s ease' }} />
      </div>
    </div>
  );
}
